import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SubmitChecklistStepMutation = graphql.persisted(
  "SubmitChecklistStep",
  graphql(`
    mutation SubmitChecklistStep($input: SubmitChecklistStepInput!) {
      submitChecklistStep(input: $input) {
        item { id state }
        errors
        nextItemId
      }
    }
  `)
);

export { SubmitChecklistStepMutation };

export function useSubmitChecklistStep() {
  return useMutation(SubmitChecklistStepMutation);
}
